export const FULL_ACCESS = "F";
export const READONLY_ACCESS = "R";
export const EDIT_ACCESS = "E";
export const NONE = "N";
